import { render, staticRenderFns } from "./RegisterSuccessPage.vue?vue&type=template&id=530a240d&"
import script from "./RegisterSuccessPage.vue?vue&type=script&lang=js&"
export * from "./RegisterSuccessPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports